import type { CSSProperties } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const useSortableItem = (id: string) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: isDragging ? 'grabbing' : undefined,
    zIndex: isDragging ? 1000 : undefined,
  };

  return {
    setNodeRef,
    style,
    isDragging,
    dragHandleProps: {
      attributes,
      listeners,
    },
    transform,
    transition,
  };
};
